module.exports = __webpack_public_path__ + "static/media/vance.abb18ba5.webp";